export default "__VITE_ASSET__e1600bab__"